import { createStore, useStore } from './store';

/**
 * Global read-only state (FR-13.2). Set by the api client whenever the server answers 402 `read_only`,
 * and shown by `<ReadOnlyBanner/>`. The workspace detail (`subscription.readOnly`, `archive`) is the primary
 * source; this store catches the case where the subscription lapsed since the workspace was loaded.
 */
export interface ReadOnlyState {
  readOnly: boolean;
  message: string | null;
}

export const readOnlyStore = createStore<ReadOnlyState>({ readOnly: false, message: null });

export function markReadOnly(message?: string): void {
  readOnlyStore.set({ readOnly: true, message: message ?? null });
}

export function clearReadOnly(): void {
  readOnlyStore.set({ readOnly: false, message: null });
}

export function useReadOnlyFlag(): ReadOnlyState {
  return useStore(readOnlyStore);
}
